import React from 'react';
import clsx from 'clsx';
import { firstErrorMessage } from '@/utils/errors';
import { pagingAttributes } from '@/hooks/paging';
import Filter from '@/components/Filter';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const ThemesFilters = ({ category, className, fluid }) => {
  const { filterTerm, readErrors } = selectors.useThemesFilters({ category });
  const updateFilterTerm = events.useUpdateThemesFilter(category);
  const fetchData = events.useFetchThemes(category);

  return (
    <Filter
      fluid={fluid}
      className={clsx('aridhia-themes-filter', className)}
      filterTerm={filterTerm}
      updateFilter={updateFilterTerm}
      error={firstErrorMessage(readErrors)}
      onFilter={() => fetchData(pagingAttributes())}
    />
  );
};

export default ThemesFilters;
